import { splitHighlights } from '@forest/shared'
import { For } from 'solid-js'

/**
 * A message's `<span style="…">` highlights, in the loss screen's highlight
 * green unless `highlightClass` colors them.
 */
export function HighlightedText(props: {
  message: string
  highlightClass?: string
}) {
  return (
    <For each={splitHighlights(props.message)}>
      {(part) =>
        part.highlighted ? (
          <span class={props.highlightClass ?? 'text-[#2AFD00]'}>
            {part.text}
          </span>
        ) : (
          part.text
        )
      }
    </For>
  )
}
